/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHemisphere = createReactComponent("hemisphere", "IconHemisphere", [
  ["path", { d: "M12 9m-9 0a9 3 0 1 0 18 0a9 3 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M3 9a9 9 0 0 0 18 0", key: "svg-1" }]
]);

export { IconHemisphere as default };
//# sourceMappingURL=IconHemisphere.js.map
